import React from 'react';

const NotFound = () => {
    return (
        <div className="h-screen ">
            <h1 className="text-5xl text-center pt-28">404 NOT FOUND</h1>
        </div>
    );
};

export default NotFound;